var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-inner" },
    [
      _c(
        "span",
        { staticClass: "search-icon", on: { click: _vm.toggleSearch } },
        [
          _c(
            "svg",
            {
              attrs: {
                width: "9px",
                height: "9px",
                viewBox: "0 0 9 9",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg",
                "xmlns:xlink": "http://www.w3.org/1999/xlink"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Symbols",
                    stroke: "none",
                    "stroke-width": "0.5",
                    fill: "none",
                    "fill-rule": "evenodd"
                  }
                },
                [
                  _c(
                    "g",
                    { attrs: { id: "Icons/Search", stroke: "#5C5C5C" } },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "Group",
                            transform: "translate(1.000000, 1.000000)"
                          }
                        },
                        [
                          _c("circle", {
                            attrs: { id: "Oval-2", cx: "3", cy: "3", r: "3" }
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M5.5,5.5 L7.5,7.5",
                              id: "Line",
                              "stroke-linecap": "square"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-in" } }, [
        _vm.active
          ? _c("div", { staticClass: "search-overlay" }, [
              _c("div", { staticClass: "input-group" }, [
                _c(
                  "form",
                  {
                    staticClass: "search-form",
                    attrs: { action: "/search", method: "get", role: "search" }
                  },
                  [
                    _c("input", {
                      ref: "inputfield",
                      attrs: {
                        type: "search",
                        name: "q",
                        id: "search",
                        value: "",
                        placeholder: "search"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        _vm.active = !_vm.active
                      }
                    }
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "18px",
                          height: "19px",
                          viewBox: "0 0 18 19",
                          version: "1.1",
                          xmlns: "http://www.w3.org/2000/svg",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink"
                        }
                      },
                      [
                        _c(
                          "g",
                          {
                            attrs: {
                              id: "Search",
                              stroke: "none",
                              "stroke-width": "1",
                              fill: "none",
                              "fill-rule": "evenodd",
                              "stroke-linecap": "square"
                            }
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: {
                                  id: "klassik-joined-search-step1",
                                  transform:
                                    "translate(-1257.000000, -59.000000)",
                                  "fill-rule": "nonzero",
                                  stroke: "#1F2D3D"
                                }
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      id: "UI/CloseX",
                                      transform:
                                        "translate(1252.000000, 55.000000)"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M5,4.82142857 L22.9737948,22.1757317 L5,4.82142857 Z",
                                        id: "Line-4"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M23.0005493,4.82142857 L5,22.174996 L23.0005493,4.82142857 Z",
                                        id: "Line-4"
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }